import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import styled from 'styled-components';
import Info from '../fields/Info';
import Btn from '../buttons/Btn';
import stores from '../../stores';
import media from '../../utils/mediaQueries';
import { StudentInfo } from './StudentInfo';

const PaymentBlock = styled.div`
  padding-bottom: 10px;
  max-width: 400px;
  ${media.mobile`
    padding-bottom: 0;
  `}
`;

const LoggedInPayment = observer((props) => {
  const { isSending } = stores.bookingStore;
  const {
    examCenter, bookSlot,
  } = props;

  return (
    <PaymentBlock>
      <StudentInfo />
      <Info examCenterType={examCenter} isLoggedIn />
      <Btn
        type="submit"
        text="Je réserve ma session"
        onClick={bookSlot}
        isLoading={isSending}
        disabled={isSending}
      />
    </PaymentBlock>
  );
});

LoggedInPayment.propTypes = {
  examCenter: PropTypes.string.isRequired,
  bookSlot: PropTypes.func.isRequired,
};

export { LoggedInPayment };
